import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AssociateCards from '../../../components/AssociateCards/AssociateCards';
import Loader from '../../../components/Loader/Loader';
import {
  addAssociateProjectApplicantsAsync,
  addAssociateProjectApplicantsStartReducer,
  getProjectsAsync,
  getProjectsStartReducer,
} from '../../../_redux/_services/ProjectsSlice';

const initalState = { data: null, message: '', isloader: true };

const AddToProject = ({ applicantIds, onReceivechildProps }) => {
  const [projectsData, setProjectsData] = useState([]);
  const [config, setConfig] = useState(findconfiguration);
  const showLoader = useSelector((state) => state.Loader);
  const projects = useSelector((state) => state.GetProjects.data);
  const ApplicatsToProjectStatus = useSelector(
    (state) => state.AddAssociateProjectApplicants.data
  );

  const dispatch = useDispatch();

  const onActionHandler = (object, type) => {
    if (type === 'searchResult') {
      object.limit = findconfiguration.limitData;
      object['isActive'] = 1;
      dispatch(getProjectsAsync(object));
    } else if (type === 'AssociatProject') {
      const payload = {
        applicantsId: applicantIds.map((x) => x.id),
        projectId: object.id,
        projectCode: object.projectCode,
      };
      dispatch(addAssociateProjectApplicantsAsync(payload));
    }
    else {
      getProjectData();
    }
  };

  useEffect(() => {
    if (ApplicatsToProjectStatus === 200) {
      onReceivechildProps(false);
      dispatch(addAssociateProjectApplicantsStartReducer(initalState));
    }
  }, [ApplicatsToProjectStatus]);

  useEffect(() => { getProjectData() }, [])

  const getProjectData = () => {
    let payload = { limit: findconfiguration.limitData, offset: findconfiguration.currentPage, keyword: '', isActive: 1 };
    dispatch(getProjectsAsync(payload));
  }

  useEffect(() => {
    if (projects && projects?.rows?.length > 0) {
      setProjectsData([]);
      let projectData = JSON.parse(JSON.stringify(projects));
      let configure = JSON.parse(JSON.stringify(config));
      configure.totalRecords = projectData.total_count; // / config.limitData
      setConfig(configure);
      setProjectsData(projectData.rows);
      dispatch(getProjectsStartReducer(initalState));
    } else if (projects) {
      setConfig(findconfiguration);
      setProjectsData([]);
    }
  }, [projects]);

  return (
    <div className="mt-5">
      {showLoader.value && !showLoader.isGlobalLoading ? <Loader /> : ''}
      {projectsData ? (
        <AssociateCards
          data={projectsData}
          selectedItems={applicantIds}
          isAImatched={false}
          searchKeyWord="Search by Project Name"
          navigateTo=""
          config={config}
          componentType="AssociatedProjects"
          onReceiveHandler={(Item, obj) => onActionHandler(Item, obj)}
        />
      ) : (
        <div className="nodatasection nodataSection">
          <img
            src={process.env.PUBLIC_URL + '/assests/nodata.svg'}
            alt="noResult"
          />
          No Find Projects
        </div>
      )}
    </div>
  );
};

export default AddToProject;

const findconfiguration = {
  recordperPage: 6,
  currentPage: 1,
  totalRecords: 0,
  limitData: 6,
  isSearchServer: true,
};